import React,{Suspense} from 'react';
import "../assets/css/styles.table.css"
import Layout from './Layout';
import  DynamicSelect from '../components/DynamicSelect';
import DynamicDataGridComponent from '../components/DynamicDataGrid'
import GridNumberPaging from '../components/GridNumberPaging'
import CustomDialog from '../components/Dialog';
import {usePaymentHook} from '../hook/PaymentHook'
import Payment from '../components/Payment'
import Box from '@mui/material/Box';
import StartEndDate from '../components/StartEndDate'
import Bindcomponent from '../utils/bindcomponent';
const PaymentList = () => {
     
    const {columns,rows,message,setmessage,typeError,setTypeError, confirmStatusOpen , setConfirmStatusOpen, roleAccess,AddProjectData, handleSelectedCustomer,
            seletedOptionsCustomer,FetchData,data,action,journalcolumns,journalrows,confirmJournalOpen,setConfirmJournalOpen,HandleSearch,FetchJournalData
            } = usePaymentHook()
  
return (
<>
  <Layout message={message} setmessage={setmessage} tipe={typeError} settipe={setTypeError}>
    <div className='pd'><b>PAYMENT LIST</b></div>
 
    <div className="pd">
        {seletedOptionsCustomer.value !== "ALL" && (
             <div style={{marginBottom:15, display:"flex"}}> 
                <button className='btn btn-success' onClick={AddProjectData} disabled={!roleAccess.CREATE}>Add Payment</button>
                <div style={{position:"absolute", right:16}}>
                <button className='btn btn-primary' onClick={(e) => setConfirmJournalOpen(true)} disabled={!roleAccess.READ}>Journal</button>
                </div>
            </div>
        )}
       
        <div style={{marginBottom:15}}>
            <Bindcomponent component='DynamicSelect' url="getPaymentCustomer" label={"{id} - {name}"} selectedvalue={seletedOptionsCustomer} value={"id"} onChange={(option) => handleSelectedCustomer(option)} appendTopOption={[{label:"ALL - ALL CUSTOMER", value:"ALL"}]}></Bindcomponent>  
            {/* <DynamicSelect url="getPaymentCustomer" label={"{id} - {name}"} selectedvalue={seletedOptionsCustomer} value={"id"} onChange={(option) => handleSelectedCustomer(option)} appendTopOption={[{label:"ALL - ALL CUSTOMER", value:"ALL"}]}></DynamicSelect> */}
        </div>
        <div style={{height:"100%"}}>
             <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} name={"paymentgrid"} rowid={"payment_code"}></Bindcomponent>  
            {/* <GridNumberPaging customcolumns={columns} rows={rows} name={"paymentgrid"} rowid={"payment_code"}></GridNumberPaging> */}
        </div>
    
    </div>

    <Bindcomponent component='Dialog' open={confirmStatusOpen} setOpen={setConfirmStatusOpen} maxWidth='sm' title={action == "ADD" ?"CREATE PAYMENT" : "UPDATE PAYMENT"} subtitle={action=="EDIT" ? "Payment Code: " + data.payment_code : ""} >
         
        <Bindcomponent component='Payment' customer={seletedOptionsCustomer} setmessage={setmessage} close={setConfirmStatusOpen} bind={async () => {
                FetchData(); 
                FetchJournalData();
            }} data={data} action={action} />  
         
    </Bindcomponent>
    {/* <CustomDialog open={confirmStatusOpen} setOpen={setConfirmStatusOpen} maxWidth='sm' title={action == "ADD" ?"CREATE PAYMENT" : "UPDATE PAYMENT"} subtitle={action=="EDIT" ? "Payment Code: " + data.payment_code : ""} >
        <Payment customer={seletedOptionsCustomer} setmessage={setmessage} close={setConfirmStatusOpen} bind={async () => {
                FetchData(); 
                FetchJournalData();
            }} data={data} action={action}></Payment>
    </CustomDialog> */}

    <Bindcomponent component='Dialog' open={confirmJournalOpen} setOpen={setConfirmJournalOpen} maxWidth='md' title={"'" + seletedOptionsCustomer.label.split("-")[1].trim() + "'"}>
        <Bindcomponent component='StartEndDate' onClick={(startdate,enddate) => HandleSearch(startdate,enddate)}></Bindcomponent>
        <div>
        <Box
            sx={{
            height: "100%",
            width: '100%',
                '& .super-app-theme--debit': {
                    backgroundColor: '#f2f2f2',
                },
                '& .super-app-theme--credit': {
                    backgroundColor: '#f7f7f7',
                },
                '& .super-app-theme--balance': {
                    backgroundColor: '#f1f1f1',
                },
                '& .super-app-theme--header': {
                    backgroundColor: '#f6f6f6',
                }
            }}
            >
            <Bindcomponent component='GridNumberPaging' customcolumns={journalcolumns} rows={journalrows} name={"journalgrid"} rowid={"rowNumber"}></Bindcomponent>
        </Box>
        </div>
       
    </Bindcomponent>

  </Layout>
</>
  );
};

export default PaymentList;